import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
const CreateRemoteChagreComponent = loadable(
  () => import("../../components/RemoteArea/CreateRemoteCharge")
);
const CreateRemoteChagre = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["remote-charge"],
    navigateURL: "/",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.REMOTE_CHARGE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Add Remote Charge
        </span>
      </div>
      <CreateRemoteChagreComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default CreateRemoteChagre;
